var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogofonasa1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162.38 83.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0063ae;}.cls-2{fill:#e63338;}.cls-3,.cls-4{fill:#fff;}.cls-3{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 70.04,
    height: 11.37
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.04,
    width: 80.33,
    height: 11.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.55,58.06C18.19,42-2.95,58.17,4.83,79.94-12.8,54,22.93,29,31,53.07c.4,1.18-2.92,5.9-3.45,5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.7,34.87c-.86,4.18,1.52,7.87,5.31,8.22s7.56-2.73,8.42-6.91S25.91,28.32,22.12,28s-7.56,2.73-8.42,6.91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.72,45.33c-1.15-3.73.2-7.44,3-8.29s6,1.47,7.16,5.19-.2,7.44-3,8.29-6-1.47-7.15-5.19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.83,58.75c-1.92-1.19-2.32-4-.91-6.25s4.1-3.12,6-1.93,2.32,4,.91,6.25-4.11,3.13-6,1.93"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.76,63.15c3.5-4.47,10.48-5,16.33-1.46a13.44,13.44,0,0,0-14,4.49,12.85,12.85,0,0,0-2.61,9.4c-2.3-4.22-2.35-9,.3-12.43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.39,50.87a15.38,15.38,0,0,0-13.28,14.7C24.08,72.8,30,77.94,37.29,77a15.37,15.37,0,0,0,13.29-14.7C50.6,55.11,44.7,50,37.39,50.87ZM36.87,76.5c-6.21.75-11.23-3.61-11.2-9.75A13.05,13.05,0,0,1,37,54.25c6.21-.76,11.23,3.6,11.2,9.75A13.06,13.06,0,0,1,36.87,76.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.93,63.34s4.9,6.06,15.18,4.78c0,0,7.67-1.53,10.12,2.54,0,0-9.4,3.45-17.59-.28q-4.38-1.66-7.71-7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.9,61.74a5,5,0,0,0-5.61-1.2c-1.66.86-1.83,2.79-.39,4.32a5,5,0,0,0,5.61,1.2c1.66-.86,1.83-2.8.39-4.32"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.73,54.12H73.29v.11l-.27,1a2.2,2.2,0,0,1-1,1H65c-3.07-.14-3.61,2.25-3.61,2.25l-1.67,6.59H69.81l-.36,1.34a2.3,2.3,0,0,1-1.2,1H59.17L56,80.26H54.42A1.8,1.8,0,0,1,53,78.72l5.54-22a3,3,0,0,1,3.23-2.56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.76,75.12H90.41l2.67-11c.45-1.69.83-3.6,1-4.85h3l-.6,3.41h.08A9.52,9.52,0,0,1,104,59.39c2.33,0,5,1,5,4.2a11.21,11.21,0,0,1-.37,2.45l-2.25,9.09c-2.29,0-2.86-.94-3-1.72l1.8-7.28a9,9,0,0,0,.25-1.94c0-1.51-.78-2.63-3.11-2.63s-5.85,2.22-6.75,6Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.87,74.13a11,11,0,0,0,4.91,1c4.21,0,7.57-1.79,7.57-5,0-1.73-1.48-3-3.68-4-1.8-.75-2.74-1.44-2.74-2.53,0-1.29,1.47-2.29,3.56-2.29a8.44,8.44,0,0,1,3.39.69l.94-2a10.33,10.33,0,0,0-4.09-.75c-4.21,0-7.2,2-7.2,4.7,0,1.57,1.27,2.88,3.56,3.86,2.09.87,2.78,1.63,2.78,2.82,0,1.34-1.47,2.47-3.76,2.47a10.66,10.66,0,0,1-4.25-.94Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.49,59.39c-8.59,0-13.66,5.55-13.66,10.85,0,2.88,2.17,5,5.68,5A8.93,8.93,0,0,0,124.2,71h.08c-.14.89-.41,1.25-.68,2.34.06.77.57,1.75,2.78,1.79,0-1.77.79-4.68,1.42-7.23l2-7.93A25.32,25.32,0,0,0,124.49,59.39Zm.37,6.87c-.94,4-4.3,6.86-7.16,6.86a3,3,0,0,1-3.35-3.35c0-4.23,4.21-8.31,9.32-8.31a9.73,9.73,0,0,1,2.33.22Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.06,59.31c-8.58,0-13.66,5.55-13.66,10.84,0,2.89,2.17,5,5.69,5a8.94,8.94,0,0,0,7.69-4.26h.08c-.14.89-.41,1.33-.68,2.42.06.77.57,1.75,2.78,1.79,0-1.77.78-4.76,1.42-7.32l2-7.92A25.42,25.42,0,0,0,157.06,59.31Zm.37,6.86c-.94,4-4.29,6.87-7.16,6.87a3,3,0,0,1-3.35-3.36c0-4.23,4.21-8.3,9.32-8.3a9.26,9.26,0,0,1,2.34.22Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.56,59.31c-6.42,0-11,4.61-11,9.62,0,3.42,2.78,6.24,7.73,6.24h0c6.62,0,11-4.86,11-9.56C90.33,62.41,87.91,59.31,82.56,59.31ZM79.74,73.1h0c-2.82,0-4.62-1.79-4.62-4.26,0-3.48,2.82-7.46,7.08-7.46,3.56,0,4.62,2.47,4.62,4.23C86.77,69.15,83.74,73.1,79.74,73.1Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 72.68,
    y: 80,
    width: 38.77,
    height: 3.44
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 111.45,
    y: 80,
    width: 47.42,
    height: 3.44
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofonasa1);
export default __webpack_public_path__ + "static/media/logofonasa1.37382924dc291cd46b241635e44814a7.svg";
export { ForwardRef as ReactComponent };